module.exports = __webpack_public_path__ + "static/media/typescript-logo.9a7e9b3a.png";